export default __webpack_public_path__ + "static/media/84.eb63e004.png";